/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeCircleMIcon16Light } from './ShapeCircleMIcon16Light';
import { ShapeCircleMIcon16Regular } from './ShapeCircleMIcon16Regular';
import { ShapeCircleMIcon16Solid } from './ShapeCircleMIcon16Solid';
import { ShapeCircleMIcon20Light } from './ShapeCircleMIcon20Light';
import { ShapeCircleMIcon20Regular } from './ShapeCircleMIcon20Regular';
import { ShapeCircleMIcon20Solid } from './ShapeCircleMIcon20Solid';
import { ShapeCircleMIcon24Regular } from './ShapeCircleMIcon24Regular';
import { ShapeCircleMIcon24Solid } from './ShapeCircleMIcon24Solid';
import { ShapeCircleMIcon32Regular } from './ShapeCircleMIcon32Regular';
import { ShapeCircleMIcon64Regular } from './ShapeCircleMIcon64Regular';
var sizes = {
    16: {
        light: ShapeCircleMIcon16Light,
        regular: ShapeCircleMIcon16Regular,
        solid: ShapeCircleMIcon16Solid,
    },
    20: {
        light: ShapeCircleMIcon20Light,
        regular: ShapeCircleMIcon20Regular,
        solid: ShapeCircleMIcon20Solid,
    },
    24: {
        regular: ShapeCircleMIcon24Regular,
        solid: ShapeCircleMIcon24Solid,
    },
    32: {
        regular: ShapeCircleMIcon32Regular,
    },
    64: {
        regular: ShapeCircleMIcon64Regular,
    },
};
export var ShapeCircleMIcon = forwardRef('ShapeCircleMIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
